// Custom JavaScript for CraveBox store

(function() {
  'use strict';
  
  function initAllSliders() {
    // Find ALL slideshow-section elements on the page
    const sliders = document.querySelectorAll('slideshow-section');
    
    if (sliders.length === 0) return;
    
    // Wait for custom element to be defined
    if (customElements.get('slideshow-section')) {
      initSliderElements(sliders);
    } else {
      customElements.whenDefined('slideshow-section').then(function() {
        initSliderElements(sliders);
      });
    }
  }
  
  function initSliderElements(sliders) {
    sliders.forEach(function(sliderEl) {
      // If swiper exists and is initialized, just update it
      if (sliderEl.swiper && sliderEl.swiper.initialized) {
        try {
          sliderEl.swiper.update();
        } catch(e) {
          // Silently fail
        }
      } else {
        // If no swiper yet, try to call init method
        if (typeof sliderEl.init === 'function') {
          try {
            sliderEl.init();
          } catch(e) {
            // Silently fail
          }
        }
      }
    });
  }
  
  // Run on page load
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(initAllSliders, 1500);
    
    // Extra checks for mobile devices (they need more time)
    if (window.innerWidth <= 749) {
      setTimeout(initAllSliders, 2500);
      setTimeout(initAllSliders, 3500);
    }
  });
  
  // Also run on window load (after all resources loaded)
  window.addEventListener('load', function() {
    setTimeout(initAllSliders, 1000);
  });
  
  // Listen for cart drawer open/update events
  document.addEventListener('click', function(e) {
    // Detect cart icon clicks or add-to-cart buttons
    if (e.target.closest('[href*="cart"]') || e.target.closest('.cart-icon') || 
        e.target.closest('[class*="cart"]') || e.target.closest('a[href="/cart"]') ||
        e.target.closest('button[type="submit"]')) {
      // Initialize slider multiple times to catch AJAX loading
      setTimeout(initAllSliders, 500);
      setTimeout(initAllSliders, 1000);
      setTimeout(initAllSliders, 1500);
      setTimeout(initAllSliders, 2000);
    }
  });
  
  // Listen for theme cart drawer events
  document.addEventListener('cart-drawer-open', function() {
    // Initialize slider when drawer opens
    setTimeout(initAllSliders, 500);
    setTimeout(initAllSliders, 1000);
    setTimeout(initAllSliders, 1500);
  });
  
  document.addEventListener('cart-drawer:refresh', function() {
    // Initialize slider when drawer refreshes
    setTimeout(initAllSliders, 500);
    setTimeout(initAllSliders, 1000);
  });
  
  // Listen for cart update events
  document.addEventListener('cart:updated', function() {
    setTimeout(initAllSliders, 800);
    setTimeout(initAllSliders, 1200);
  });
  
  
  // Override quick-add behavior in cart cross-sell
  function handleCrossSellAddToCart() {
    document.addEventListener('click', function(e) {
      const addButton = e.target.closest('.wt-cart__cross-sell .shoppable-video__add-button');
      if (!addButton) return;
      
      // Prevent quick-add modal from opening
      e.preventDefault();
      e.stopPropagation();
      
      // Get product URL from button
      const productUrl = addButton.getAttribute('data-product-url');
      if (!productUrl) return;
      
      // Add to cart via AJAX
      fetch(productUrl + '.js')
        .then(response => response.json())
        .then(product => {
          const formData = {
            items: [{
              id: product.variants[0].id,
              quantity: 1
            }]
          };
          
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData)
          });
        })
        .then(response => response.json())
        .then(data => {
          // Trigger cart drawer refresh event
          document.dispatchEvent(new CustomEvent('cart-drawer:refresh', {
            bubbles: true,
            detail: data
          }));
          
          // Also trigger generic cart update event
          document.dispatchEvent(new CustomEvent('cart:updated', {
            bubbles: true
          }));
        })
        .catch(error => {
          // Silently fail
        });
    }, true); // Use capture phase to intercept before quick-add
  }
  
  // Initialize cross-sell add-to-cart handler
  handleCrossSellAddToCart();
  
  // Re-initialize slider when cart drawer content updates
  function setupCartDrawerObserver() {
    if (!window.MutationObserver) return;
    
    const cartObserver = new MutationObserver(function(mutations) {
      let crossSellAdded = false;
      
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            // Check if cross-sell section was added
            if ((node.classList && node.classList.contains('wt-cart__cross-sell')) ||
                (node.querySelector && node.querySelector('.wt-cart__cross-sell'))) {
              crossSellAdded = true;
            }
          }
        });
      });
      
      if (crossSellAdded) {
        // Reinitialize slider after cross-sell loads
        setTimeout(initAllSliders, 300);
        setTimeout(initAllSliders, 800);
      }
    });
    
    // Try to find and observe cart drawer
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      cartObserver.observe(cartDrawer, {
        childList: true,
        subtree: true
      });
    } else {
      // Cart drawer doesn't exist yet, try again later
      setTimeout(setupCartDrawerObserver, 500);
    }
  }
  
  // Set up observer after DOM is ready
  setTimeout(setupCartDrawerObserver, 500);
  setTimeout(setupCartDrawerObserver, 1500);
  
  // Also watch for cart-drawer element being added to DOM (in case it loads late)
  if (window.MutationObserver) {
    const bodyObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && node.tagName === 'CART-DRAWER') {
            // Cart drawer just appeared, set up observer for it
            setupCartDrawerObserver();
          }
        });
      });
    });
    
    bodyObserver.observe(document.body, {
      childList: true,
      subtree: false // Only watch direct children of body
    });
  }
  
})();
